
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M46.335 27.774c-.8-1.9-2.2-1.6-3.9-1.6 1.7-4-1.3-9.3-2.8-13.4-.1-.3-.2-.5-.3-.6-.4-.6-1 .5-1 1-.2 2.5-4.6 4.8-6.6 5.3-3.3.9-6.4 0-9.5 1.8-2.2 1.2-4.2 3.4-4.6 5.9-1.4-.1-2.6 0-3.3 1.6-1.2 2.8 1.1 7.5 2.6 9.8 1.7 2.6 4.1 4.6 6.8 5.8-.1 1.5-.2 3.5.8 4.2 1.3.8 4.4.2 5.8.2h3.8c.5 0 1.4.1 1.9-.2 1-.6 1-2.7.9-4.2 2.7-1.2 5.1-3.1 6.8-5.8 1.5-2.2 3.8-7.1 2.6-9.8zm-24.6-4c1.3-.9 2.9-1.6 4.5-1.8 2.7-.4 5.1.1 7.6-1.1 1.7-.8 3.7-2.4 4.8-4.3.1.8.2 1.5 0 2.3-.6 3.1-4.2 3.9-6.9 4.1-1 .1-.9 3.2 0 3.2 3.7-.3 7.1-1.5 8.1-5.4.2-.8.3-1.5.3-2.3 1.2 2.9 2 5.9-.9 7.7h-20.1c.6-.8 2.4-2.2 2.6-2.4zm14.2 21.9c.1-.1-.3-.2-.5-.2-1.5.3-3.5 0-5.1 0-1.6 0-3.5.3-5 0-.1 0-.5 0-.6.1-.1-.2 0-.9 0-1v-.8c1.7.6 3.6 1 5.5 1.1 1.9-.1 3.8-.5 5.5-1.1v.6c.2.1.3 1.2.2 1.3zm6.4-9.8c-2.9 3.8-7.3 5.7-12 5.9-4.5-.2-8.7-1.9-11.6-5.4-.4-.5-1.2-1.6-1.9-2.7h21.7c1 0 1-3.2 0-3.2h-22.8c0-.2.1-.4.1-.5.6-1.1-.1-.3 1-.7.3-.1.7-.2 1.2-.2.2.3.3.2.5 0 1.3 0 2.8.2 3.8.2h15.5c.4 0 .8 0 1.3-.1.1.1.2.1.4 0h.1c1.4-.1 2.9-.2 4 .1.3.1 1-.2 1.2 0 1.2 1.3-1.7 5.6-2.5 6.6z"}})])
          )
        }
      }
    